export default new class RightColumn {
  constructor() {
    this.preFooterFormSelector = '_right-column-form-pdf';
    this.preFooterInputField = '_input-field';
    this.preFooterNameInputSelector = '_right-column-name-input';
    this.preFooterEmailInputSelector = '_right-column-email-input';
    this.formPrivacyPolicyInputSelector = '_right-column-privacypolicy-input';
    this.submitBtnSelector = '_right-column-pdf-submit';
    this.inValidSelector = '_invalid';
    this.successSelector = '_right-column-success';
    this.successVisibleSelector = 'subscribe__success_visible';
    this.preLoaderSelector = '_right-column-form-preloader';
    this.delay = 2000;

    this.loadRightColumn();

    $('body').on('click', `.${this.submitBtnSelector}`, () => {
      this.handler();
    });
  }

  // eslint-disable-next-line class-methods-use-this
  loadRightColumn() {
    if ($(document).width() <= 1200) {
      $('#right-form').prependTo($('#right-column-mobile'));
    }
  }

  handler() {
    const form = document.querySelector(`.${this.preFooterFormSelector}`);

    if (!form) return;
    setTimeout(() => {
      this.checkForm(form);
    }, 0);
  }

  checkForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    const privacypolicy = form.querySelector(`.${this.formPrivacyPolicyInputSelector}`);
    if (privacypolicy.checked === false) {
      privacypolicy.focus();
      return;
    }

    const inputName = form.querySelector(`.${this.preFooterNameInputSelector}`);
    const name = inputName.value;

    const inputEmail = form.querySelector(`.${this.preFooterEmailInputSelector}`);
    const email = inputEmail.value;

    // eslint-disable-next-line camelcase
    const page_url = window.location.href;

    $.request('Download::onSignupFile', {
      data: {
        name,
        email,
        page_url,
      },
      loading: `.${this.preLoaderSelector}`,
      complete: (res) => {
        this.showSuccess(res);
        setTimeout(() => {
          const link = document.createElement('a');
          link.setAttribute('href', '/storage/app/media/download-files/Oshibki-avtomatizacii.pdf');
          link.setAttribute('download', 'Ошибки автоматизации.pdf');
          link.click();
          this.hideSuccess();
        }, this.delay);
      },
    });
  }

  showSuccess(res) {
    const { statusText } = res;
    if ((statusText === 'success') || (statusText === 'OK')) {
      $(`.${this.successSelector}`).addClass('show');
      // eslint-disable-next-line no-undef
      ym(71321556, 'reachGoal', 'download_manual');
    }
  }

  hideSuccess() {
    $(`.${this.successSelector}`).removeClass('show');
  }
}();
